'use client';

import Link from 'next/link';
import FAQAccordion from '../common/FAQAccordion';

export const faqs = [
  {
    question: 'What is LoveUPDF?',
    answer:
      'LoveUPDF is a privacy-first, free online PDF platform. We offer 9 tools: merge, split, sign, compress, rotate, lock, unlock, organize, and remove pages. All tools are 100% free with no account required. Files never leave your device for most tools, and server-side tools auto-delete instantly after processing.',
  },
  {
    question: 'Is LoveUPDF really free?',
    answer:
      'Yes. All PDF tools are 100% free. No hidden fees, no subscriptions, no credit cards, no premium tiers. Every feature is available to everyone at no cost.',
  },
  {
    question: 'Are my files private when I use LoveUPDF?',
    answer:
      'Yes, completely. Files are encrypted with 256-bit SSL during any transfer. Client-side tools process in your browser with no upload whatsoever. Server-side tools process in memory and are permanently deleted immediately after download. We never store your documents.',
  },
  {
    question: 'Do I need to create an account to use LoveUPDF?',
    answer:
      'No account, no email, no login required. Just visit the site and use any tool directly in your browser. We do not track who you are or what you process.',
  },
  {
    question: 'Does LoveUPDF work on mobile devices?',
    answer:
      'Yes. LoveUPDF works perfectly on iPhone, Android, iPad, and desktop. Any device with a modern browser can access all tools with the same full functionality.',
  },
  {
    question: 'What PDF tools does LoveUPDF offer?',
    answer:
      'LoveUPDF offers 9 free PDF tools: merge PDF, split PDF, sign PDF, compress PDF, rotate PDF, lock PDF with password, unlock PDF, organize PDF pages, and remove PDF pages. All tools are free and privacy-first.',
  },
  {
    question: "What's the difference between client-side and server-side tools?",
    answer:
      'Client-side tools (merge, split, rotate, organize, remove pages) process entirely in your browser. Files never leave your device. Server-side tools (compress, lock, unlock, sign PDF) process in server memory and are permanently deleted immediately after download. Both approaches give your privacy equal priority.',
  },
  {
    question: 'How long are my files stored on LoveUPDF?',
    answer:
      'For client-side tools, files never leave your device so nothing is ever stored. For server-side tools (compress, lock, unlock, sign PDF), files are processed in memory and permanently deleted immediately after download, typically within seconds. We never keep copies.',
  },
  {
    question: 'Can I use LoveUPDF for commercial purposes?',
    answer:
      'Yes. All tools are free for personal and commercial use with no restrictions. Process business documents, client files, or work projects without any limitations.',
  },
];

export default function FAQSection() {
  return (
    <section className="py-20 px-4 sm:px-6 bg-white" aria-labelledby="faq-heading">
      <div className="max-w-3xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-10">
          <p className="text-sm font-semibold mb-3 text-primary tracking-[0.05em] uppercase">FAQ</p>
          <h2
            id="faq-heading"
            className="font-heading font-extrabold mb-3 text-[clamp(26px,4vw,36px)] text-brand-dark"
          >
            Common Questions
          </h2>
          <p className="text-brand-mid text-[15px]">
            Quick answers about our privacy-first PDF tools.
          </p>
        </div>

        {/* FAQ accordion */}
        <FAQAccordion faqs={faqs} />

        {/* Support CTA */}
        <div className="mt-8 p-5 rounded-xl text-center  bg-[linear-gradient(135deg,#FFF0F2_0%,#FFE8EB_100%)] border-[1.5px] border-primary-mid dark:bg-[linear-gradient(0deg,#111727_0%,#0c2131_100%)] dark:border-primary-mid">
          <p className="font-heading font-bold text-[17px] text-brand-dark dark:text-white mb-1.5">
            Need help?
          </p>

          <p className="text-brand-mid dark:text-gray-300 text-[14px] font-body mb-4">
            Our support team is here to help you get the most out of LoveUPDF.
          </p>

          <Link
            href="/contact"
            className="btn-primary inline-flex items-center px-6 py-2.5 text-sm bg-primary text-white dark:bg-primary dark:text-white rounded-[100px] font-heading font-bold no-underline"
          >
            Contact Support
          </Link>
        </div>
      </div>
    </section>
  );
}
